
  import { defineComponent, toRefs } from 'vue';
  import { Field } from '@/ui/components/form/Field';
  import AssigneesDropdown from '@/ui/pages/user/assignees/AssigneesDropdown.vue';
  import { ValidationError } from '@/entities/validation';
  import { SelectOptions } from '@/ui/types';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';

  type AssigneesType = Array<number | string>;

  export default defineComponent({
    name: 'AssigneesField',
    components: {
      Field,
      AssigneesDropdown,
    },
    props: {
      name: { type: String, default: 'assignees' },
      label: { type: String, default: '' },
      required: { type: Boolean, default: false },
      errors: { type: Array as () => ValidationError[], required: true },
      disabled: { type: Boolean, default: false },
      value: { type: Array as () => AssigneesType, required: true },
      options: { type: Array as () => SelectOptions, required: true },
      disabledExternalAssignee: { type: Boolean, default: false },
      nonVisibleOptions: { type: Array as () => SelectOptions, default: () => [] },
      tooltipText: { type: String, default: null },
    },
    emits: ['input', 'update-options'],
    setup(props, { emit }) {
      const { options, value, nonVisibleOptions } = toRefs(props);

      const updateValue = async (id: number) => {
        emitChange([...value.value, `user_${id}`]);
        toasted.success(t('user.created'), { duration: 5000 });

        emit('update-options');
      };

      const emitChange = (value: Array<string|number>) => {
        emit('input', value);
      };

      return {
        fieldOptions: options,
        fieldValue: value,
        fieldNonVisibleOptions: nonVisibleOptions,
        emitChange,
        updateValue,
      };
    },
  });
